import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ReleaseModel } from '../help/models/release.model';
import { UserResourceModel } from '../help/models/user-resource.model';
import { HelpSelectors } from '../help/state/selectors/help.selectors';
import { RouterSelectors } from '../help/state/selectors/router.selectors';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';

@Component({
  selector: 'jsg-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  @Select(HelpSelectors.getRedirectUri) redirectUri$!: Observable<string>;

  @SelectSnapshot(RouterSelectors.getRoutePath) routePath: string;

  ngOnInit(): void {
    if (this.routePath) {
      console.log('Path: ' + this.routePath);
    }
  }
}
